import React, {Component} from 'react';
import {Dropdown, DropdownMenuItemType, ISelectableOption} from "office-ui-fabric-react";
import ApiService from "../ApiService";
import {
    MisDataServiceTypes,
} from "../../models/SchoolMailroomConfigDto";

interface MisFetchAvailableDataServiceDropdownProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    dataServiceType: MisDataServiceTypes;
    onSelect(dataServiceType: MisDataServiceTypes): void
}

interface MisFetchAvailableDataServiceDropdownState {
    currentType?: MisDataServiceTypes | null;
}

export default class MisFetchAvailableDataServiceDropdown extends Component<MisFetchAvailableDataServiceDropdownProps, MisFetchAvailableDataServiceDropdownState> {

    static displayName = MisFetchAvailableDataServiceDropdown.name;

    constructor(props: MisFetchAvailableDataServiceDropdownProps) {
        super(props);

        this.state = {
            currentType: undefined
        };
    }

    async componentDidMount() {

        const config = await this.props.apiService.getMailroomSchoolConfig(this.props.tenantId, this.props.schoolCode);

        this.setState({
            currentType: config.misDataServiceType,
        });
    }

    async componentDidUpdate(prevProps: MisFetchAvailableDataServiceDropdownProps, prevState: MisFetchAvailableDataServiceDropdownState): Promise<void> {

    }

    onRenderOption = (option: ISelectableOption | undefined): JSX.Element => {
        
        const currentPill = (<span className={"pill pill--blue pill--tiny"}>Current</span>);
        
        return (
            <div>
                {option?.text} {option?.key === this.state.currentType ? currentPill : null}
            </div>
        );
    };
    
    public render()
    {
        if(this.state.currentType === undefined)
        {
            return null;
        }
        
        const options = [
            { key: 'cloudHeader', text: 'Cloud', itemType: DropdownMenuItemType.Header },
            { key: 'divider1', text: '-', itemType: DropdownMenuItemType.Divider },
            { key: MisDataServiceTypes.SalamanderHosted, text: "Hosted Salamander"},
            { key: MisDataServiceTypes.Arbor, text: "Arbor"},
            { key: MisDataServiceTypes.DeveloperTestData, text: "DeveloperTestData"},
            { key: 'schoolServerHeader', text: 'School Server', itemType: DropdownMenuItemType.Header },
            { key: 'divider2', text: '-', itemType: DropdownMenuItemType.Divider },
            { key: MisDataServiceTypes.SalamanderWebService, text: 'Salamander Web Service'}
        ]
        
        return (
            <Dropdown
                label={"Data Service Type"}
                styles={{ dropdown: { width: 300 } }}
                options={options}
                selectedKey={this.props.dataServiceType}
                onRenderOption={this.onRenderOption}
                onChange={(e,o) => this.props.onSelect(o?.key as MisDataServiceTypes)}
            />
        );
    };
}